<div class="container single-view" id="view-warranty">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        @if (isGlobalSearch) {
          <a data-testid="back-btn" [routerLink]="['/warranties']" [queryParams]="{ tab: 'global-search' }" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'WARRANTIES.BTN_BACK_TO_WARRANTY' | translate }}</a>
        } @else {
          <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/warranties" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'WARRANTIES.BTN_BACK_TO_WARRANTY' | translate }}</a>
        }
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="warranty-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'WARRANTY_SINGLE_VIEW.WARRANTY_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
              @if (warrantyData.code) {
                <span data-testid="warranty-code">
                  {{ warrantyData.code | defaultValue }}
                </span>
              }
              @if (warrantyData.isActive) {
                <span data-testid="warranty-isactive" class="tag tag-green flex items-center">
                  {{ 'ENUMS.ACTIVE' | translate }}
                </span>
              }
              @if (!warrantyData.isActive) {
                <span data-testid="warranty-isactive" class="tag tag-red flex items-center">
                  {{ 'ENUMS.INACTIVE' | translate }}
                </span>
              }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4" [ngClass]="{'basis-full mt-2': warrantyData.isActive}">
          <div id="complementary-details" class="flex flex-wrap">
            @if (warrantyData.activationDate) {
              <span class="flex items-center mr-2" pTooltip="{{ 'WARRANTY_SINGLE_VIEW.TOOLTIP_ACTIVATION_DATE' | translate }}" tooltipPosition="top">
                <i class="icon icon-calendar-tick mr-1"></i>
                {{ warrantyData.activationDate | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
              </span>
            }
            @if (warrantyData.endDate) {
              <span class="flex items-center mr-2" pTooltip="{{ 'WARRANTY_SINGLE_VIEW.TOOLTIP_END_DATE' | translate }}" tooltipPosition="top">
                <i class="icon icon-calendar-cross mr-1"></i>
                {{ warrantyData.endDate | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
              </span>
            }
          </div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3 mt-2">
            @if (allowDisassociateWarranty) {
              <button data-testid="dissasociate-btn" id="btn-disassociate-warranty" class="btn outline-btn red-outline" (click)="onTriggerVoidDisassociate()" [disabled]="!(!warrantyData.isActive && warrantyData.itemId != null && !warrantyData.isPrepaired && !warrantyData.useLimitReached) || warrantyData.isItemStolen">
                {{ 'WARRANTY_SINGLE_VIEW.BTN_DISASSOCIATE' | translate }}
              </button>
            }
            @if (allowVoidWarranty) {
              <button data-testid="void-btn" id="btn-void-warranty" [disabled]="!warrantyData.isActive || warrantyData.isItemStolen" class="btn outline-btn red-outline" (click)="onTriggerVoidWarranty()">
                {{ 'WARRANTY_SINGLE_VIEW.BTN_VOID' | translate }}
              </button>
            }
            @if (allowExtendWarranty) {
              <button data-testid="extend-btn" id="btn-extend-warranty-details" [disabled]="!extendEnabled || warrantyData.isItemStolen" class="btn outline-btn" (click)="onTriggerExtendWarranty()">
                {{ 'WARRANTY_SINGLE_VIEW.BTN_EXTEND_WARRANTY' | translate }}
              </button>
            }
            @if (delete) {
              <button data-testid="delete-btn" [disabled]="!canBeDeleted || warrantyData.isItemStolen" id="btn-delete-warranty" class="btn red-btn" (click)="showDeleteDialog()">
                {{ 'WARRANTIES.BTN_DELETE' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
             <section class="row">
              <div class="col-12">
                <h4 data-testid='warranty-details'>{{ 'WARRANTY_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">
                  @if (companyIsPrepaired) {
                    <dt data-testid="warranty-isprepaired-label" class="label grid-cols-1 pt-3">{{ 'WARRANTY_SINGLE_VIEW.PRE_PAIRED' | translate }}</dt>
                    <dd data-testid="warranty-isprepaired" class="value pt-3 pb-3">{{ warrantyData.isPrepaired | friendlyBoolean | defaultValue }}</dd>
                  }

                  <dt data-testid='warranty-activationdate-label' class="label grid-cols-1 pt-3">{{ 'WARRANTY_SINGLE_VIEW.ACTIVATION_DATE' | translate }}</dt>
                  <dd data-testid='warranty-activationdate' class="value pt-3 pb-3">{{ warrantyData.activationDate | date: 'dd-MM-yyyy HH:mm' | defaultValue }}</dd>

                  <dt data-testid='warranty-enddate-label' class="label grid-cols-1 pt-3">{{ 'WARRANTY_SINGLE_VIEW.END_DATE' | translate }}</dt>
                  <dd data-testid='warranty-enddate' class="value pt-3 pb-3">{{ warrantyData.endDate | date: 'dd-MM-yyyy HH:mm' | defaultValue }}</dd>

                  <dt data-testid='warranty-timesused-label' class="label grid-cols-1 pt-3">{{ 'WARRANTY_SINGLE_VIEW.TIMES_USED' | translate }}</dt>
                  <dd data-testid='warranty-timesused'  class="value pt-3 pb-3">{{ warrantyData.timesUsed | defaultValue }}</dd>

                </dl>
              </div>
             </section>
            <section class="row">
              <div class="col-12 mb-3">
                <h4 data-testid='warranty-operation-details'>{{ 'WARRANTY_SINGLE_VIEW.OPERATIONS_HISTORY' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              </div>
              <div class="col-12">
                <p-table [value]="filteredWarrantyOperationData" #dtWarrantyHistoryTable>
                  <ng-template #header>
                    <tr>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'WARRANTY_SINGLE_VIEW.TH_DATE' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'WARRANTY_SINGLE_VIEW.SERIAL_NUMBER' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'WARRANTY_SINGLE_VIEW.SKU' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'WARRANTY_SINGLE_VIEW.TH_OPERATION_TYPE' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'WARRANTY_SINGLE_VIEW.TH_COMMENT' | translate }}</span>
                        </div>
                      </th>
                      @if (!isGlobalSearch) {
                        <th>
                          <div class="header-wr">
                            <span class="col-name">
                              {{ 'TABLE.FILTER.Actions' | translate }}
                            </span>
                          </div>
                        </th>
                      }
                    </tr>
                  </ng-template>
                  <ng-template #body let-operation>
                    <tr>
                      <td>
                        <span class="p-column-title">{{ 'WARRANTY_SINGLE_VIEW.TH_DATE' | translate }}:</span>
                        {{ operation?.operationDate | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'WARRANTY_SINGLE_VIEW.TH_SERIAL_NUMBER' | translate }}:</span>
                        @if (operation?.itemId && allowViewItems) {
                          <a [routerLink]="['/items/', operation?.itemId]" class="inline-flex items-center link">{{ operation?.itemSerialNumber | defaultValue }}</a>
                        } @else {
                          {{ operation?.itemSerialNumber | defaultValue }}
                        }
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'WARRANTY_SINGLE_VIEW.SKU' | translate }}:</span>
                        {{ operation?.productSku | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'WARRANTY_SINGLE_VIEW.TH_OPERATION_TYPE' | translate }}:</span>
                        {{ operation?.warrantyOperationType | warrantyOperationTypePipe | defaultValue }}
                        @if(operation?.revertedById != null && operation?.warrantyOperationType == warrantyOperationType.Extend)
                        {
                          <span class="reverted-extension">({{ 'WARRANTY_SINGLE_VIEW.VOIDED' | translate }})</span>
                        }
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'WARRANTY_SINGLE_VIEW.TH_COMMENT' | translate }}:</span>
                        {{ operation?.comment | defaultValue }}
                      </td>
                      @if (!isGlobalSearch) {
                        <td>
                          @if (operation == getLatestExtendOperation()) {
                            <button type="button" tooltipPosition="top" pTooltip="{{ 'WARRANTY_SINGLE_VIEW.TOOLTIP_VOID_EXTENSION' | translate }}" class="btn-icon-only ui-btn-delete btn-icon icon-delete mr-2" (click)="onTriggerVoidWarrantyExtension()" [attr.data-testid]="'btn-delete'">
                              <span class="btn-label">{{ 'SYSTEM_SETTINGS.ROLES.DELETE_ROLE' | translate }}</span>
                            </button>
                          }
                        </td>
                      }
                    </tr>
                  </ng-template>
                  <ng-template #emptymessage>
                    <tr>
                      @if (isGlobalSearch) {
                        <td colspan="5">
                          {{ 'WARRANTY_SINGLE_VIEW.NO_OPERATIONS_DATA' | translate }}
                        </td>
                      } @else {
                        <td colspan="6">
                          {{ 'WARRANTY_SINGLE_VIEW.NO_OPERATIONS_DATA' | translate }}
                        </td>
                      }
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </section>
             <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation: extend warranty -->
<p-dialog [header]="'MODALBOXES.TITLE_EXTEND_WARRANTY' | translate" [(visible)]="displayExtendWarrantyModalbox" [modal]="true" (onHide)="onHideExtendWarrantyAction()" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <form [formGroup]="extendWarrantyFormGroup">
    <div class="row">
      <div class="field-wr col-12 col-sm-12 col-md-8">
        <label data-testid='warranty-extend-retailer-label' for="durationInMonths" class="mb-2">{{ 'MODALBOXES.LABEL_RETAILER' | translate }} <i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="extend-retailer"
          [placeholder]="'MODALBOXES.SELECT_RETAILER' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="false"
          [searchMode]="'remote'"
          [pageSize]="storesRowsPerPageOption"
          [totalCount]="storesTotalRecords"
          [totalPages]="getTotalPages(storesTotalRecords, storesRowsPerPageOption)"
          [options]="storesList"
          formControlName="retailer"
          (onLazyLoad)="onLazyLoadStores($event)">
        </app-custom-dropdown>
      </div>
      @if (canExtendD2C) {
        <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
          <div class="row">
            <div class="col-12">
              <span class="label text-sm">{{ 'MODALBOXES.D2C' | translate }}</span>

              <label for="d2c-yes" data-testid="extend-warranty-d2c-yes-label" class="inline-flex mr-6">
                <p-radioButton data-testid="extend-warranty-d2c-yes" value="true" formControlName="isD2C" inputId="d2c-yes" />
                <span class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
              </label>

              <label for="d2c-no" data-testid="extend-warranty-d2c-no-label" class="inline-flex mr-2">
                <p-radioButton data-testid="extend-warranty-d2c-no" value="false" formControlName="isD2C" inputId="d2c-no" />
                <span class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
              </label>
            </div>
          </div>
        </div>
        }
      <div class="field-wr col-12 col-sm-12 col-md-4" [ngClass]="{'disabled': extendWarrantyFormGroup.get('isD2C')?.value == 'true'}">
        <label data-testid='warranty-extend-durationinmonths-label' for="durationInMonths"><i class="icon-required-field"></i>{{ 'MODALBOXES.LABEL_EXTENSION_PERIOD' | translate }}</label>
        <input data-testid='warranty-extend-durationinmonths' type="number" id="code" formControlName="durationInMonths"
          placeholder="{{ 'MODALBOXES.EXTENSION_PERIOD_PLACEHOLDER' | translate }}" autocomplete="off">
      </div>
      <div class="field-wr col-12 col-sm-12 col-md-12">
        <label data-testid='warranty-extend-reason-label' for="extendReason">{{ 'MODALBOXES.LABEL_EXTEND_REASON' | translate }} <i class="icon-required-field"></i></label>
        <textarea ata-testid='warranty-extend-reason' class="text-sm" formControlName="extendReason" rows="3" placeholder="{{ 'MODALBOXES.EXTEND_REASON_PLACEHOLDER' | translate }}" id="extendReason"></textarea>
        @if (
          extendWarrantyFormGroup.get('extendReason')?.invalid &&
          extendWarrantyFormGroup.get('extendReason')?.touched
        ) {
          <small class="error">
            {{ 'MODALBOXES.HINT_EXTEND_REASON_REQUIRED' | translate }}.
          </small>
        }
      </div>
    </div>
  </form>
  <ng-template #footer>
    <button data-testid="warranty-extend-cancel-btn" type="button" class="btn outline-btn" (click)="onCancelExtendWarranty()">{{
      'MODALBOXES.BTN_CANCEL_EXTEND' | translate }}</button>
    <button data-testid="warranty-extend-confirm-btn" t type="button" class="btn primary-btn" (click)="onConfirmExtendWarranty()"
      [disabled]="extendWarrantyFormGroup.invalid">{{ 'MODALBOXES.BTN_CONFIRM_EXTEND_WARRANTY' | translate }}</button>
  </ng-template>
</p-dialog>
<!-- Modalbox: void last extension -->
<p-dialog [header]="'MODALBOXES.TITLE_VOID_WARRANTY_EXTENSION' | translate" [(visible)]="displayVoidWarrantyExtensionModalbox" [modal]="true" (onHide)="onHideVoidWarrantyExtensionAction()" [blockScroll]="true" [draggable]="false" [resizable]="false" [style]="{ height: '35vh' }">
  <form [formGroup]="voidWarrantyExtensionFormGroup">
    <div class="row">
      <div class="field-wr col-12 col-sm-12 col-md-5">
        <label data-testid='void-retailer-label' class="mb-2">{{ 'MODALBOXES.LABEL_RETAILER' | translate }} <i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="void-retailer"
          [placeholder]="'MODALBOXES.SELECT_RETAILER' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="storesRowsPerPageOption"
          [totalCount]="storesTotalRecords"
          [totalPages]="getTotalPages(storesTotalRecords, storesRowsPerPageOption)"
          [options]="storesList"
          formControlName="retailer"
          (onLazyLoad)="onLazyLoadStores($event)">
        </app-custom-dropdown>
    </div>
    </div>
  </form>
  <ng-template #footer>
    <button data-testid="void-cancel-btn" type="button" class="btn outline-btn" (click)="onCancelVoidWarrantyExtension()">{{
      'MODALBOXES.BTN_CANCEL_VOID' | translate }}</button>
    <button data-testid="void-confirm-btn" type="button" class="btn primary-btn" (click)="onConfirmVoidWarrantyExtension()"
      [disabled]="voidWarrantyExtensionFormGroup.invalid">{{ 'MODALBOXES.BTN_CONFIRM_VOID_WARRANTY_EXTENSION' | translate }}</button>
  </ng-template>
</p-dialog>
<!-- Modalbox: void warranty -->
<p-dialog [header]="'MODALBOXES.TITLE_VOID_WARRANTY' | translate" [(visible)]="displayVoidWarrantyModalbox" [modal]="true" (onHide)="onHideVoidWarrantyAction()" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <form [formGroup]="voidWarrantyFormGroup">
    <div class="row">
      <div class="field-wr col-12 col-sm-12 col-md-5">
        <label data-testid='void-retailer-label' for="durationInMonths" class="mb-2">{{ 'MODALBOXES.LABEL_RETAILER' | translate }} <i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="void-retailer"
          [placeholder]="'MODALBOXES.SELECT_RETAILER' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="storesRowsPerPageOption"
          [totalCount]="storesTotalRecords"
          [totalPages]="getTotalPages(storesTotalRecords, storesRowsPerPageOption)"
          [options]="storesList"
          formControlName="retailer"
          (onLazyLoad)="onLazyLoadStores($event)">
        </app-custom-dropdown>
      </div>
      <div class="field-wr col-12 col-sm-12 col-md-3">
        <label data-testid='void-manualvoiddate-label' for="manualVoidDate" class="mb-2">{{ 'MODALBOXES.LABEL_SET_MANUAL_VOID_DATE' | translate }}</label>
        <label data-testid="manual-voiddate-yes-label" class="inline-flex mr-6">
          <p-radioButton data-testid="manual-voiddate-yes" name="manualVoidDate" [value]="true" formControlName="manualVoidDate" inputId="yes" />
          <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
        </label>
        <label data-testid="manual-voiddate-no-label" class="inline-flex mr-2">
          <p-radioButton data-testid="manual-voiddate-no" name="manualVoidDate" [value]="false" formControlName="manualVoidDate" inputId="no" />
          <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
        </label>
      </div>
      <div class="field-wr col-12 col-sm-12 col-md-4"
        [ngClass]="{ 'disabled': voidWarrantyFormGroup.get('manualVoidDate')?.value === false }">
        <label data-testid='void-voiddate-label'  for="VoidDate">{{ 'MODALBOXES.LABEL_SELECT_VOID_DATE' | translate }} <i
            class="pi pi-question-circle" role="tooltip" pTooltip="{{ 'TOOLTIP.DATE_FORMAT' | translate }}"
            tooltipPosition="top" id="dateTooltip"></i></label>
        <p-datepicker data-testid='void-voiddate' formControlName="voidDate" dateFormat="dd-mm-yy" [maxDate]="currentDate"
          placeholder="{{ 'MODALBOXES.VOID_DATE_PLACEHOLDER' | translate }}" showIcon="true" [showTime]="true" appendTo="body"
          inputId="VoidDate" />
      </div>
      <div class="field-wr col-12 col-sm-12 col-md-12">
        <label data-testid='void-reason-label' for="voidReason">{{ 'MODALBOXES.LABEL_VOID_REASON' | translate }} <i class="icon-required-field"></i></label>
        <textarea data-testid='void-reason' class="text-sm" formControlName="voidReason" rows="3" placeholder="{{ 'MODALBOXES.VOID_REASON_PLACEHOLDER' | translate }}" id="voidReason"></textarea>
        @if (
          voidWarrantyFormGroup.get('voidReason')?.invalid &&
          voidWarrantyFormGroup.get('voidReason')?.touched
        ) {
          <small data-testid="void-error" class="error">
            {{ 'MODALBOXES.HINT_RETURN_REASON_REQUIRED' | translate }}.
          </small>
        }
      </div>
    </div>
  </form>
  <ng-template #footer>
    <button data-testid="void-cancel-btn" type="button" class="btn outline-btn" (click)="onCancelVoidWarranty()">{{
      'MODALBOXES.BTN_CANCEL_VOID' | translate }}</button>
    <button data-testid="void-confirm-btn" type="button" class="btn primary-btn" (click)="onConfirmVoidWarranty()"
      [disabled]="voidWarrantyFormGroup.invalid">{{ 'MODALBOXES.BTN_CONFIRM_VOID_WARRANTY' | translate }}</button>
  </ng-template>
</p-dialog>

<!-- Modalbox: Disassociate warranty -->
<p-dialog [header]="'MODALBOXES.TITLE_DISASSOCIATE_WARRANTY' | translate" [(visible)]="displayDisassociateWarrantyModalbox" [modal]="true" (onHide)="onHideDisassociateWarrantyAction()" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <form [formGroup]="disassociateWarrantyFormGroup">
    <div class="row">
      <div class="field-wr col-12 col-sm-12 col-md-5">
        <label data-testid="disassociate-retailer-label" for="durationInMonths" class="mb-2">{{ 'MODALBOXES.LABEL_RETAILER' | translate }} <i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="disassociate-retailer"
          [placeholder]="'MODALBOXES.SELECT_RETAILER' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="storesRowsPerPageOption"
          [totalCount]="storesTotalRecords"
          [totalPages]="getTotalPages(storesTotalRecords, storesRowsPerPageOption)"
          [options]="storesList"
          formControlName="retailer"
          (onLazyLoad)="onLazyLoadStores($event)">
        </app-custom-dropdown>
      </div>
      <div class="field-wr col-12 col-sm-12 col-md-3">
        <label data-testid="disassociate-manualdisassociate-label" for="manualDisassociateDate" class="mb-3">{{ 'MODALBOXES.LABEL_SET_MANUAL_DISASSOCIATE_DATE' | translate }}</label>
        <span class="inline-flex mr-6">
          <p-radioButton data-testid="manual-disassociate-date-no" name="manualDisassociateDate" value="true" formControlName="manualDisassociateDate" inputId="yes" />
          <label for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</label>
        </span>
        <span class="inline-flex mr-2">
          <p-radioButton data-testid="manual-disassociate-date-yes" name="manualDisassociateDate" value="false" formControlName="manualDisassociateDate" inputId="no" />
          <label for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</label>
        </span>
      </div>
      <div class="field-wr col-12 col-sm-12 col-md-4"
        [ngClass]="{'disabled': disassociateWarrantyFormGroup.get('manualDisassociateDate')?.value == false}">
        <label data-testid="disassociate-disassociatedate-label" for="DisassociateDate">{{ 'MODALBOXES.LABEL_SELECT_DISASSOCIATE_DATE' | translate }} <i
            class="pi pi-question-circle" role="tooltip" pTooltip="{{ 'TOOLTIP.DATE_FORMAT' | translate }}"
            tooltipPosition="top" id="dateTooltip"></i></label>
        <p-datepicker data-testid="disassociate-disassociatedate" formControlName="disassociateDate" dateFormat="dd-mm-yy" [maxDate]="currentDate"
          placeholder="{{ 'MODALBOXES.DISASSOCIATE_DATE_PLACEHOLDER' | translate }}" showIcon="true" [showTime]="true" appendTo="body"
          inputId="disassociateDate" />
      </div>
      <div class="field-wr col-12 col-sm-12 col-md-12">
        <label data-testid="disassociate-reason-label" for="disassociateReason">{{ 'MODALBOXES.LABEL_DISASSOCIATE_REASON' | translate }} <i class="icon-required-field"></i></label>
        <textarea data-testid="disassociate-reason"  class="text-sm" formControlName="disassociateReason" rows="3" placeholder="{{ 'MODALBOXES.DISASSOCIATE_REASON_PLACEHOLDER' | translate }}" id="disassociateReason"></textarea>
        @if (
          disassociateWarrantyFormGroup.get('disassociateReason')?.invalid &&
          disassociateWarrantyFormGroup.get('disassociateReason')?.touched
        ) {
          <small class="error">
            {{ 'MODALBOXES.HINT_RETURN_REASON_REQUIRED' | translate }}.
          </small>
        }
      </div>
    </div>
  </form>
  <ng-template #footer>
    <button data-testid="disassociate-cancel-btn" type="button" class="btn outline-btn" (click)="onCancelDisassociateWarranty()">{{
      'MODALBOXES.BTN_CANCEL_DISASSOCIATE' | translate }}</button>
    <button data-testid="disassociate-confirm-btn" type="button" class="btn primary-btn" (click)="onConfirmDisassociateWarranty()"
      [disabled]="disassociateWarrantyFormGroup.invalid">{{ 'MODALBOXES.BTN_CONFIRM_DISASSOCIATE_WARRANTY' | translate }}</button>
  </ng-template>
</p-dialog>

<!-- Delete warranty -->
<dialog-reason  #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_WARRANTY'" (onClose)="deleteWarranty($event)"></dialog-reason>
